import React from "react"
import { Loader } from "../../../../../../../Shared/Frontend/utils/loader"
import { renderSearchItems, SearchPageLayout } from "../../searchPage/searchPage.layout" 
import { getSearchQueryFromUrl } from "../overviewWidget.api"
import { OverviewState } from "../overviewWidget.state"
import { OverviewItemsLayout } from "./overviewItems.layout"
import { NewsOverviewLayout } from "../../newsOverviewPage/newsOverviewPage.layout"
import { StoryOverviewLayout } from "../../storyOverviewPage/storyOverviewPage.layout"
import { RecentNewsBlockLayout } from "../../../../modernBlocks/blocks/recentNewsBlock/recentNewsBlock.layout"

export function renderOverviewItems(overviewState: OverviewState): JSX.Element {
    if (overviewState.overviewItems.kind != "loaded") {
        return <Loader type="inline" />
    }

    if (overviewState.overviewItemsCacheKeyName == "search") {
        const searchTerm = getSearchQueryFromUrl();
        return (
            <SearchPageLayout.Wrap count={overviewState.overviewItems.value.pager.totalItems} searchTerm={searchTerm}>
                {overviewState.overviewItems.value.items.size == 0
                    ? <SearchPageLayout.Empty searchTerm={searchTerm}/>
                    : (
                        <>
                            {renderSearchItems(overviewState.overviewItems.value.items/*, overviewState.overviewItems.value.suggestions */)}
                        </>
                    )
                }
            </SearchPageLayout.Wrap>
        )
    }

    if (overviewState.overviewItemsCacheKeyName == "news")
        return <NewsOverviewLayout.Wrap>
            <RecentNewsBlockLayout.Teasers>
                {overviewState.overviewItems.value.items.map((item, key) => {
                    return <RecentNewsBlockLayout.Teaser
                        key={key}
                        teaserKey={`recentNewsBlock-t-${key}`}
                        link={item.Link!}
                        title={item.Title}
                        intro={item.Description}
                        date={new Date(item.LastUpdated)}
                        image={item.image}
                    />
                })}
            </RecentNewsBlockLayout.Teasers>
        </NewsOverviewLayout.Wrap>

    if (overviewState.overviewItemsCacheKeyName == "verhalen")
        return <StoryOverviewLayout.Wrap>
            <StoryOverviewLayout.Teasers>
                {overviewState.overviewItems.value.items.map((item, key) => {
                    return <StoryOverviewLayout.Teaser
                        key={key}
                        index={key}
                        teaserKey={`story-overview-t-${key}`}
                        link={item.Link!}
                        title={item.Title}
                        intro={item.Description}
                        image={item.image}
                    />
                })}
            </StoryOverviewLayout.Teasers>
        </StoryOverviewLayout.Wrap>

    return <OverviewItemsLayout.Empty />
}